var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-64"},[_c('div',{ref:"map",staticClass:"h-full w-full"})])}
var staticRenderFns = []

export { render, staticRenderFns }